export default "__VITE_ASSET__397e7be2__"